import {useEffect, useRef} from "react";
import {Col} from "../../components/Flex/Flex";
import style from '../../style/Map.module.css';
import {getPos, UserLocation} from "../../utils/MapUtils.tsx";
import {useSWCLocation} from "../../utils/api.ts";


interface RouteMapProps {
    route: Route,
    otherRoutes: Route[],
    start: RouteSystem,
    end: RouteSystem,
    highlight: string;
    flipped: boolean;
}
interface LocationStartEndProps {
    location: RouteSystem;
    highlight: string;
}
interface LocationMidProps {
    location: Segment;
    highlight: string;
}
export default function RouteMap({route, otherRoutes, start, end, highlight, flipped}: RouteMapProps) {
    const ref = useRef(null);
    const stops = route.path.slice(1, -1);
    const {location} = useSWCLocation();

    return (
        <Col ref={ref} grow={100} shrink={1} className={style.wrapper}>
            <MapCanvas stops={route.path} alternatives={otherRoutes}/>
            <div className={style.legend}>
                <div>Start Location: <div className={style.dotGreen}/></div>
                <div>Path Location: <div className={style.dotBlue}/></div>
                <div>End Location: <div className={style.dotRed}/></div>
                {location ? <div>Current Location: <div className={style.dotPurple} /></div> : null}
            </div>
            <div className={style.dotWrapper}>
                {stops.map(s => <StopLocation key={s.id} location={s} highlight={highlight} />)}
                <StartLocation location={flipped ? end : start} highlight={highlight} />
                <EndLocation location={flipped ? start : end} highlight={highlight} />
                <UserLocation location={location} />
            </div>
        </Col>
    )
}


const StartLocation = ({location, highlight}: LocationStartEndProps) => {
    return <div className={highlight === location.id ? style.systemHigh : style.system} style={{bottom: getPos(location.galY), left: getPos(location.galX)}} title={location.name}>
        <div className={style.dotGreen}/>
    </div>
}
const EndLocation = ({location, highlight}: LocationStartEndProps) => {
    return <div className={highlight === location.id ? style.systemHigh : style.system} style={{bottom: getPos(location.galY), left: getPos(location.galX)}} title={location.name}>
        <div className={style.dotRed}/>
    </div>
}
const StopLocation = ({location, highlight}: LocationMidProps) => {
    return <div className={highlight === location.id ? style.systemHigh : style.system} style={{bottom: getPos(location.y), left: getPos(location.x)}} title={location.name} ><div className={style.dotBlue} /></div>;
}

const drawMap = (canvas: HTMLCanvasElement, stops: Segment[], alternatives: Route[], scale=1) => {
    const context = canvas.getContext('2d');
    if(!context) {
        return;
    }
    context.strokeStyle = 'rgb(71,139,164)';
    context.lineWidth = 2;
    for(let r of alternatives) {
        context.beginPath();
        let started = false;
        for(let stop of r.path) {
            let x = (stop.x + 500)*scale;
            let y = (-stop.y + 500)*scale;

            if(!started) {
                context.moveTo(x,y);
                started = true;
            } else {
                context.lineTo(x,y);
            }
        }
        context.stroke();
    }



    context.strokeStyle = 'rgb(10,161,10)';
    context.lineWidth = 3;

    context.beginPath();
    let started = false;
    for (let stop of stops) {
        let x = (stop.x + 500)*scale;
        let y = (-stop.y + 500)*scale;




        if(!started) {
            context.moveTo(x,y);
            started = true;
        } else {
            context.lineTo(x,y);
        }


    }
    context.stroke();



    return () => {
        context.clearRect(0, 0, canvas.width, canvas.height);
    }
}
const MapCanvas = ({stops, alternatives}: {stops: Segment[], alternatives: Route[]}) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            return drawMap(canvas, stops, alternatives);
        }
    }, [stops]);


    return (
        <canvas className={style.canvas} ref={canvasRef} width={1000} height={1000}></canvas>
    )
}
